Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    colors = _STYLES$useStyles.colors,
    fontRegular = _STYLES$useStyles.fontRegular,
    fontBold = _STYLES$useStyles.fontBold,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing;
  var imageWidth = 160;
  if (bp.is([bp.mobile_m, bp.mobile_l])) {
    imageWidth = 250;
  }
  if (bp.is([bp.mobile_xl])) {
    imageWidth = 300;
  }
  if (bp.tablet) {
    imageWidth = 300;
  }
  if (bp.desktop) {
    imageWidth = 430;
  }
  var _valueWidth = (0, _styles.getREM)(4.5);
  if (bp.is([bp.mobile_l, bp.mobile_xl, bp.tablet, bp.desktop])) {
    _valueWidth = (0, _styles.getREM)(5.5);
  }
  var _gap = spacing.s;
  if (bp.is([bp.tablet, bp.desktop])) {
    _gap = spacing.l;
  }
  var saveButton = {
    alignSelf: 'center',
    marginTop: _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(spacing.normal, ")") : -1 * spacing.normal
  };
  var table = {};
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m])) {
    table.marginLeft = _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(spacing.page.padding.paddingLeft, ")") : -1 * spacing.page.padding.paddingLeft;
    table.marginRight = _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(spacing.page.padding.paddingRight, ")") : -1 * spacing.page.padding.paddingRight;
  }
  var tableHeading = {
    textAlign: 'left'
  };
  if (bp.not([bp.desktop])) {
    tableHeading.textAlign = 'center';
  }
  var tableHead = {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingBottom: spacing.normal,
    paddingLeft: _gap,
    paddingRight: _gap
  };
  var tableHeadLabel = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: _styles.STYLES.lineHeight.xs,
    width: _valueWidth,
    textAlign: 'center',
    paddingLeft: _gap
  }, _reactNative.Platform.select({
    web: {
      boxSizing: 'content-box'
    }
  }));
  if (bp.is([bp.mobile_l, bp.mobile_xl, bp.tablet, bp.desktop])) {
    tableHeadLabel.fontSize = _styles.STYLES.fontSize.s;
    tableHeadLabel.lineHeight = _styles.STYLES.lineHeight.s;
  }
  var row = {
    borderBottomWidth: (0, _styles.getREM)(0.0625),
    borderBottomColor: COLORS.steam,
    borderStyle: 'solid',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: spacing.s,
    paddingBottom: spacing.s,
    paddingLeft: _gap,
    paddingRight: _gap
  };
  var row_first = {
    borderTopWidth: (0, _styles.getREM)(0.0625),
    borderTopColor: COLORS.steam,
    borderStyle: 'solid'
  };
  var row_odd = {
    backgroundColor: COLORS.paper
  };
  var rowIcon = {
    marginRight: _gap,
    width: (0, _styles.getREM)(1.375),
    height: (0, _styles.getREM)(1.375)
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    rowIcon.display = 'none';
  }
  if (bp.is([bp.tablet, bp.desktop])) {
    rowIcon.width = (0, _styles.getREM)(2.375);
    rowIcon.height = (0, _styles.getREM)(2.375);
  }
  var rowLabel = Object.assign({}, fontRegular, {
    marginRight: 'auto',
    color: colors.text,
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: _styles.STYLES.lineHeight.xs
  });
  if (bp.is([bp.tablet, bp.desktop])) {
    rowLabel.fontSize = _styles.STYLES.fontSize.m;
    rowLabel.lineHeight = _styles.STYLES.lineHeight.m;
  }
  var rowValue = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.normal,
    width: _valueWidth,
    textAlign: 'center',
    color: COLORS.aubergine,
    paddingLeft: _gap
  }, _reactNative.Platform.select({
    web: {
      boxSizing: 'content-box'
    }
  }), {
    flexShrink: 0
  });
  if (bp.is([bp.tablet, bp.desktop])) {
    rowValue.fontSize = _styles.STYLES.fontSize.normal;
    rowValue.lineHeight = _styles.STYLES.lineHeight.l;
  }
  var rowValueNumber = Object.assign({}, fontBold, {
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal
  });
  if (bp.is([bp.tablet, bp.desktop])) {
    rowValueNumber.fontSize = _styles.STYLES.fontSize.l;
    rowValueNumber.lineHeight = _styles.STYLES.lineHeight.l;
  }
  var messageContainer = {
    borderRadius: (0, _styles.getREM)(1),
    backgroundColor: COLORS.snuff,
    padding: spacing.s,
    marginTop: spacing.normal,
    marginBottom: spacing.xl
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    messageContainer.padding = spacing.m;
  }
  var messageText = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: _styles.STYLES.lineHeight.xs,
    color: COLORS.aubergine
  });
  if (bp.is([bp.tablet, bp.desktop])) {
    messageText.fontSize = _styles.STYLES.fontSize.m;
    messageText.lineHeight = _styles.STYLES.lineHeight.m;
  }
  var styles = _reactNative.StyleSheet.create({
    saveButton: saveButton,
    table: table,
    tableHeading: tableHeading,
    tableHead: tableHead,
    tableHeadLabel: tableHeadLabel,
    row: row,
    row_first: row_first,
    row_odd: row_odd,
    rowIcon: rowIcon,
    rowLabel: rowLabel,
    rowValue: rowValue,
    rowValueNumber: rowValueNumber,
    messageContainer: messageContainer,
    messageText: messageText
  });
  return {
    styles: styles,
    imageWidth: imageWidth
  };
};